export const getCategoryColor = (category: string | null) => {
    if (!category) return 'bg-gray-100 text-gray-800';

    const lowerCat = category.toLowerCase();
    if (lowerCat.includes('revenue') || lowerCat.includes('income') || lowerCat.includes('sales')) {
        return 'bg-emerald-100 text-emerald-800';
    } else if (lowerCat.includes('cogs') || lowerCat.includes('cost of goods')) {
        return 'bg-amber-100 text-[#8C7720]';
    } else if (lowerCat.includes('labor') || lowerCat.includes('payroll') || lowerCat.includes('salary')) {
        return 'bg-[#E3DFFF] text-[#453F6B]';
    } else if (lowerCat.includes('expense') || lowerCat.includes('opex') || lowerCat.includes('operating')) {
        return 'bg-blue-100 text-blue-800';
    } else if (lowerCat.includes('draw') || lowerCat.includes('equity') || lowerCat.includes('distribution')) {
        return 'bg-indigo-100 text-indigo-800';
    } else if (lowerCat.includes('asset') || lowerCat.includes('equipment')) {
        return 'bg-cyan-100 text-cyan-800';
    } else if (lowerCat.includes('liability') || lowerCat.includes('loan')) {
        return 'bg-rose-100 text-rose-800';
    }

    // Fallback deterministic color for other categories
    const colors = [
        'bg-pink-100 text-pink-800',
        'bg-fuchsia-100 text-fuchsia-800',
        'bg-violet-100 text-violet-800',
        'bg-sky-100 text-sky-800',
        'bg-teal-100 text-teal-800',
        'bg-lime-100 text-lime-800'
    ];

    let hash = 0;
    for (let i = 0; i < category.length; i++) {
        hash = category.charCodeAt(i) + ((hash << 5) - hash);
    }

    const index = Math.abs(hash) % colors.length;
    return colors[index];
};
